import React from "react";
import BaseButton from "components/ui_components/buttons/BaseButton";

const baseStyles = `
    font-size: 13px;
    border-radius: 5px;
    transition: opacity .5s;
    min-width: 64px;
    font-weight: 500;
    text-transform: none;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 76, 106);
    transition: background-color 0.5s;
    padding: 7px 25px;
  `;

const extraStyles = {
  outlined: `
    border: 1px solid;
    padding: 6px 24px;
  `,
  contained: `
    padding: 7px 25px;
  `,
};

const WidgetControlButton = (props) => {
  let defaultStyles = baseStyles;

  if (props.variant === "contained") {
    defaultStyles += extraStyles.contained;
  } else if (props.variant === "outlined") {
    defaultStyles += extraStyles.outlined;
    // Ensure outlined buttons have transparent background and specific hover color
    defaultStyles += `
      background: transparent !important;
      color: rgb(0, 76, 106);
      &:hover { background: rgba(0, 151, 210, 0.1) !important; }
    `;
  }

  return (
    <BaseButton
      defaultStyles={defaultStyles}
      loading={props.loading}
      {...props}
    >
      {props.children}
    </BaseButton>
  );
};

export default WidgetControlButton;

WidgetControlButton.defaultProps = {
  color: null,
  themePaletteColor: "primary.main",
  variant: "contained",
  loading: false,
};
